import { logger } from './logger'
import { merge } from 'lodash-es'
import { DEFAULT_LOCAL_STORAGE_KEY } from '../config'

/**
 * Loads settings from localStorage only if settings.byLocalStorage is true or a string.
 * If settings.byLocalStorage is a string, it will be used as a key for localStorage.
 * If settings.byLocalStorage is true, the default key will be used (see {@link DEFAULT_LOCAL_STORAGE_KEY})
 *
 * @param settings - settings to be merged with localStorage settings
 */
export function loadSettingsFromLocalStorage<T extends { byLocalStorage?: boolean | string }> (settings: T): T {
  if (settings.byLocalStorage == null || settings.byLocalStorage === false) {
    return settings
  }

  // by default, set the key to the default key
  let key = DEFAULT_LOCAL_STORAGE_KEY

  // if byLocalStorage is a string, use it as the localStorage key
  if (typeof settings.byLocalStorage === 'string') {
    key = settings.byLocalStorage
  }
  logger.debug('Loading settings from localStorage with key:', key)

  // get the settings from localStorage
  const jsonSettings = window.localStorage.getItem(key)
  if (jsonSettings == null) return settings

  // parse the settings from json
  const parsedSettings = JSON.parse(jsonSettings)
  logger.debug('Loaded settings from localStorage', parsedSettings)

  // merge the settings prioritizing the settings from localStorage
  const mergedSettings = merge({}, settings, parsedSettings)
  return mergedSettings as T
}
